module.exports = __webpack_public_path__ + "img/google-play-badge.445ecd84.png";